module.exports = __webpack_public_path__ + "assets/img/item02.c5ac4998.svg";